export default function MeritSection() {
  const merits = [
    {
      icon: 'ri-shield-check-line',
      tag: 'Merit 01',
      title: 'ワンストップで\nすべておまかせ',
      desc: '害虫駆除（予防）・庭の手入れ・清掃・住居点検・補修まで、複数の業者に連絡する手間は一切不要。「家のことはここに電話すれば大丈夫」という安心感を、月額定額でご提供します。',
      items: ['害虫駆除・予防処置', '庭の草刈り・剪定', '室内外の清掃', '屋根・外壁・水回り点検', '小規模補修対応'],
      img: 'https://public.readdy.ai/ai/img_res/8b23ea99a93a7aeb4df7bb18ad9986de.jpg',
    },
    {
      icon: 'ri-map-pin-2-line',
      tag: 'Merit 02',
      title: '創業15年・法人化10年\n地域密着の安心感',
      desc: '岡山県南部で15年間、地域の皆さまの家を守り続けてきました。水路が多く湿気の高い岡山南部特有の環境を熟知しているからこそ、的確な予防と対処が可能です。地元に根ざした信頼ある会社だから、長くお付き合いいただけます。',
      items: ['岡山県南部の環境を熟知', '地元スタッフが迅速対応', '緊急時も相談しやすい', '年間500件以上の相談実績'],
      img: 'https://readdy.ai/api/search-image?query=Friendly%20Japanese%20local%20service%20team%20in%20matching%20uniforms%20standing%20in%20front%20of%20a%20Japanese%20house%2C%20smiling%20and%20trustworthy%2C%20Okayama%20residential%20area%2C%20warm%20sunlight%2C%20professional%20and%20approachable%2C%20high%20quality%20photo&width=600&height=400&seq=merit002&orientation=landscape',
    },
    {
      icon: 'ri-chat-smile-2-line',
      tag: 'Merit 03',
      title: '写真付きLINE報告で\n離れた家族も安心',
      desc: '作業完了後は必ず写真付きでLINEにご報告。「今日はこんな作業をしました」「ここが少し気になりました」と、離れて暮らすご家族にもリアルタイムで状況をお伝えします。遠方のお子さんも、スマホで実家の様子を確認できます。',
      items: ['作業前後の写真を送付', '気になる箇所も報告', '家族のLINEにも共有可', '月次レポートも提供'],
      img: 'https://readdy.ai/api/search-image?query=Japanese%20person%20looking%20at%20smartphone%20showing%20LINE%20app%20with%20house%20maintenance%20report%20photos%2C%20warm%20home%20interior%20background%2C%20soft%20natural%20light%2C%20reassuring%20and%20peaceful%20atmosphere%2C%20high%20quality%20photo&width=600&height=400&seq=merit003&orientation=landscape',
    },
  ];

  return (
    <section id="merit" aria-label="サービスの3つのメリット" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            選ばれる3つの理由
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            安心して、ずっと住み続けられる家へ
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto">
            「家の管理おまかせパック」が岡山県南部の多くのご家庭に選ばれる理由をご紹介します。
          </p>
        </div>

        {/* Merit Cards */}
        <div className="flex flex-col gap-10 md:gap-14">
          {merits.map((m, i) => (
            <div
              key={i}
              className={`flex flex-col ${i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-10 items-center`}
            >
              {/* Image */}
              <div className="w-full md:w-2/5 shrink-0">
                <div className="w-full h-56 md:h-64 rounded-lg overflow-hidden">
                  <img
                    src={m.img}
                    alt={m.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>

              {/* Text */}
              <div className="flex-1">
                <span className="text-xs font-bold text-amber-600 tracking-widest">{m.tag}</span>
                <div className="w-8 h-8 flex items-center justify-center bg-amber-50 rounded-full mt-2 mb-3">
                  <i className={`${m.icon} text-amber-600 text-lg`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-black text-stone-800 leading-snug mb-3 whitespace-pre-line" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {m.title}
                </h3>
                <p className="text-stone-600 text-sm md:text-base leading-relaxed mb-4">{m.desc}</p>
                <ul className="flex flex-wrap gap-2">
                  {m.items.map((item) => (
                    <li key={item} className="flex items-center gap-1 text-xs text-stone-600 bg-stone-50 px-3 py-1.5 rounded-full border border-stone-100">
                      <i className="ri-check-line text-amber-500 text-xs"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
